import React, { useState } from 'react';
import Seo from '../components/Seo';
// Modal with arrows for navigating rooms
function ImageModal({ open, roomIndex, rooms, onClose, onPrev, onNext }) {
  if (!open) return null;
  const room = rooms[roomIndex];
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      background: 'rgba(0,0,0,0.65)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000
    }} onClick={onClose}>
      <div style={{position: 'relative', background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px rgba(0,0,0,0.25)', padding: 24, maxWidth: '96vw', maxHeight: '92vh', display: 'flex', flexDirection: 'column', alignItems: 'center'}} onClick={e => e.stopPropagation()}>
        {/* Close (X) Button */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 10,
            right: 10,
            background: 'rgba(123,30,58,0.85)',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 34,
            height: 34,
            fontSize: 20,
            fontWeight: 900,
            cursor: 'pointer',
            zIndex: 3,
            lineHeight: 1
          }}
          aria-label="Close"
        >&#10005;</button>
        {/* Left Arrow */}
        <button
          onClick={onPrev}
          style={{
            position: 'absolute',
            left: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(123,30,58,0.85)',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 38,
            height: 38,
            fontSize: 22,
            cursor: 'pointer',
            display: roomIndex === 0 ? 'none' : 'block',
            zIndex: 2
          }}
          aria-label="Previous room"
        >&#8592;</button>
        {/* Right Arrow */}
        <button
          onClick={onNext}
          style={{
            position: 'absolute',
            right: 8,
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(123,30,58,0.85)',
            color: '#fff',
            border: 'none',
            borderRadius: '50%',
            width: 38,
            height: 38,
            fontSize: 22,
            cursor: 'pointer',
            display: roomIndex === rooms.length - 1 ? 'none' : 'block',
            zIndex: 2
          }}
          aria-label="Next room"
        >&#8594;</button>
        <img
          src={room.img}
          alt={room.imgAlt}
          style={{
            maxWidth: '80vw',
            maxHeight: '60vh',
            borderRadius: 10,
            marginBottom: 18,
            boxShadow: '0 2px 8px #0002'
          }}
        />
        <div style={{textAlign: 'center'}}>
          <div style={{fontWeight: 900, fontSize: '1.25rem', color: '#7b1e3a', marginBottom: 4}}>{room.name}</div>
          <div style={{fontWeight: 600, fontSize: '1.08rem', color: '#3a6c5a'}}>{room.price}</div>
        </div>
      </div>
    </div>
  );
}


const rooms = [
  {
    name: 'Harte Room (Board Room)',
    price: 'Hourly: £18.00 | Full Day: £135.00',
    imgAlt: 'Board Room',
    color: '#7b1e3a',
    img: require('../assets/images/Board_Room.jpg'),
  },
  {
    name: 'Herzog Room (Training Room)',
    price: 'Hourly: £18.00 | Full Day: £135.00',
    imgAlt: 'Training Room',
    color: '#e67c30',
    img: require('../assets/images/Conference_Training_Room.jpg'),
  },
  {
    name: 'Carmichael Room (Conference Room)',
    price: 'Hourly: £22.00 | Full Day: £160.00',
    imgAlt: 'Conference Room',
    color: '#3a6c5a',
    img: require('../assets/images/Carmichael_Room.jpg'),
  },
  {
    name: 'Hewitt Room (Computer & Training Room)',
    price: 'Hourly: £25.00 | Full Day: £175.00',
    imgAlt: 'Computer Room',
    color: '#b48a78',
    img: require('../assets/images/ICT_Suite.jpg'),
  },
];


function RoomHire() {
  const [modal, setModal] = useState({ open: false, roomIndex: 0 });
  return (
    <>
      <Seo
        title="Room Hire at the Vine Centre | Venue Hire North Belfast"
        description="Hire a room at the Vine Centre for your event, meeting, or group. Modern facilities in North Belfast. View room options and enquire today."
      />
      <div className="programme-detail roomhire-modern" style={{maxWidth: 1000, margin: '0 auto', padding: '2.5em 1em'}}>
        <ImageModal
          open={modal.open}
          roomIndex={modal.roomIndex}
          rooms={rooms}
          onClose={() => setModal({ open: false, roomIndex: 0 })}
          onPrev={e => {
            e.stopPropagation();
            setModal(m => ({ ...m, roomIndex: Math.max(0, m.roomIndex - 1) }));
          }}
          onNext={e => {
            e.stopPropagation();
            setModal(m => ({ ...m, roomIndex: Math.min(rooms.length - 1, m.roomIndex + 1) }));
          }}
        />
        <div className="roomhire-hero" style={{background: 'linear-gradient(120deg, #e6f7f2 0%, #f7e6ee 100%)', borderRadius: 22, padding: '2.8em 2em 2.2em 2em', boxShadow: '0 4px 32px rgba(123,30,58,0.13)', textAlign: 'center', marginBottom: 44}}>
          <h1 style={{color: '#7b1e3a', fontWeight: 900, fontSize: '2.4rem', marginBottom: 12, letterSpacing: 1}}>Room Hire at the Vine Centre</h1>
          <p style={{color: '#3a6c5a', fontSize: '1.22rem', maxWidth: 700, margin: '0 auto'}}>
            Purpose-built rooms for meetings, training, conferences, and events. Affordable rates, catering, and equipment hire available.
          </p>
        </div>
        <div className="roomhire-rooms" style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '2.5em', margin: '2.5em 0'}}>
          {rooms.map(room => (
          <div key={room.name} className="feature-card" style={{background: '#fff', borderRadius: 18, boxShadow: '0 4px 18px rgba(123,30,58,0.10)', padding: '1.7em 1.2em', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div
              style={{height: 120, width: '100%', maxWidth: 220, background: room.color + '22', borderRadius: 10, marginBottom: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', color: room.color, fontSize: 22, fontWeight: 700, border: `2px dashed ${room.color}`, cursor: 'pointer'}}
              onClick={() => setModal({ open: true, roomIndex: rooms.indexOf(room) })}
              title="Click to enlarge"
            >
              <img src={room.img} alt={room.imgAlt} style={{maxHeight: 110, maxWidth: '95%', borderRadius: 8, objectFit: 'cover', boxShadow: `0 2px 8px ${room.color}22`}} />
            </div>
            <h3 style={{color: room.color, fontWeight: 900, fontSize: '1.18rem', marginBottom: 6}}>{room.name}</h3>
            <p style={{fontWeight: 600, color: '#3a6c5a', fontSize: '1.05rem'}}>{room.price}</p>
          </div>
        ))}
      </div>
      <div className="roomhire-catering" style={{margin: '2.5em 0'}}>
        <h2 style={{color: '#7b1e3a', fontWeight: 900, fontSize: '1.3rem', marginBottom: 12}}>Catering Options (per person)</h2>
        <ul style={{columns: 2, maxWidth: 600, margin: '1.5em auto', color: '#3a6c5a', fontWeight: 600, fontSize: '1.05rem'}}>
          <li>Tea/Coffee & Biscuits – £1.00</li>
          <li>Tea/Coffee & Scones – £1.50</li>
          <li>Jug of Juice – £1.00</li>
          <li>Sandwiches – £2.00</li>
          <li>Soup/Stew – £1.00</li>
          <li>Traybake – £0.50</li>
          <li>Sausage Rolls – £0.50</li>
          <li>Cocktail Sausages – £0.50</li>
          <li>Chicken Pieces – £1.00</li>
        </ul>
      </div>
      <div className="roomhire-equipment" style={{margin: '2.5em 0'}}>
        <h2 style={{color: '#7b1e3a', fontWeight: 900, fontSize: '1.3rem', marginBottom: 12}}>Equipment Hire</h2>
        <ul style={{columns: 2, maxWidth: 600, margin: '1.5em auto', color: '#3a6c5a', fontWeight: 600, fontSize: '1.05rem'}}>
          <li>Data Projector & Screen – £25.00</li>
          <li>OHP Projector & Screen – £15.00</li>
          <li>Screen – £5.00</li>
          <li>Flipchart & Pens – £10.00</li>
        </ul>
      </div>
      <div className="roomhire-contact" style={{background: '#f7e6ee', borderRadius: 14, padding: '1.7em 2.2em', color: '#7b1e3a', fontWeight: 700, textAlign: 'center', margin: '2.5em 0 0 0', fontSize: '1.13rem'}}>
        <span>For room hire enquiries, contact <strong>Claire Adams</strong> on <a href="tel:02890351020">(028) 9035 1020</a> or <a href="mailto:info@vinecentre.org">info@vinecentre.org</a>.</span>
      </div>
    </div>
    </>
  );
}

export default RoomHire;
